var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipse101 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 8,
  viewBox: "0 0 17 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.6441 7.56808C15.6441 3.91906 12.3902 0.960938 8.37626 0.960938C4.36233 0.960938 1.1084 3.91906 1.1084 7.56808",
  stroke: "white",
  strokeWidth: 1.32143
})));
export { SvgEllipse101 as ReactComponent };
export default __webpack_public_path__ + "86b84b768afe3cdbae8451b44b54e02b.svg";